<template lang="pug">
#tabela-gestao-contrato-originacao
    .tabela-gestao-contrato-originacao__tabela
        el-table(
            :data='tabelaData',
            v-loading='carregando',
            stripe,
            :default-sort='{ prop: "date", order: "descending" }',
            @sort-change='sortChangeRequest',
            style='width: 100%'
        )
            el-table-column(prop='numeroContrato', label='Número do contrato')
            el-table-column(
                prop='material',
                label='Cultura',
                width='130',
                sortable
            )
            el-table-column(
                prop='safraNome',
                label='Safra',
                width='130',
                sortable
            )
            el-table-column(
                prop='volumeContratado',
                label='Volume contratado (t)',
                width='200',
                sortable
            )
            el-table-column(
                prop='dataContrato',
                label='Data da última atualização',
                width='220',
                sortable
            )
            el-table-column(
                prop='saldoRestante',
                label='Saldo restante (t)',
                sortable
            )
            el-table-column(prop='statusSubEmpresa', label='Status', sortable)
                .template(slot-scope='scope')
                    .status-processamento {{ scope.row.statusSubEmpresa }}

            el-table-column(label='Ações', align='center', width='90')
                .template.d-flex.justify-content-center.tabela-gestao-icone(
                    slot-scope='scope'
                )
                    el-dropdown.action-button(trigger='click')
                        span.el-dropdown-link
                            i.mdi.mdi-dots-vertical
                        el-dropdown-menu(slot='dropdown')
                            el-dropdown-item(
                                icon='el-icon-view',
                                v-if='scope.row.statusSubEmpresaCodigo !== "AGUARDANDO_PREENCHIMENTO"',
                                @click.native='visualizarProcessamento(scope.row.numeroContrato)'
                            )
                                | Visualizar contrato
                            el-dropdown-item(
                                icon='el-icon-edit',
                                v-if='codigosPreencher[scope.row.statusSubEmpresaCodigo]',
                                @click.native='irParaContrato(scope.row.numeroContrato)'
                            ) Preencher
                            el-dropdown-item(
                                icon='el-icon-edit',
                                v-if='codigosEdicao[scope.row.statusSubEmpresaCodigo]',
                                @click.native='irParaContrato(scope.row.numeroContrato)'
                            ) Editar
            template(slot='empty')
                el-empty(description='Sem dados')

    .tabela-gestao-contrato-originacao__paginacao
        span.pagina
            | {{ paginacao.total }} contratos

        el-pagination(
            background,
            :page-size='paginacao.itensPorPagina',
            :pager-count='5',
            :current-page.sync='paginacao.pagina + 1',
            layout='prev, pager, next',
            :total='paginacao.total',
            @current-change='mudarPagina'
        )
</template>

<script>
import ModalDetalheAnalise from '@/components/contratosOriginacao/ModalDetalheAnalise.vue';

export default {
    name: 'TabelaGestaoContratoOriginacao',
    components: { ModalDetalheAnalise },
    props: {
        tabelaData: {
            type: Array,
            required: true
        },
        paginacao: {
            type: Object,
            required: true
        },
        carregando: {
            type: Boolean,
            required: false
        }
    },
    data() {
        return {
            codigosPreencher: {
                AGUARDANDO_PREENCHIMENTO: 'AGUARDANDO_PREENCHIMENTO'
            },
            codigosEdicao: {
                EM_CADASTRAMENTO: 'EM_CADASTRAMENTO',
                EM_PROCESSAMENTO: 'EM_PROCESSAMENTO',
                PROCESSADO_VOLUME_INCOMPLETO: 'PROCESSADO_VOLUME_INCOMPLETO',
                PROCESSADO_INCONFORMIDADE: 'PROCESSADO_INCONFORMIDADE',
                PROCESSADO_AGUARDANDO_ENVIO: 'PROCESSADO_AGUARDANDO_ENVIO'
            }
        };
    },
    methods: {
        mudarPagina(novaPagina) {
            this.$emit('mudarPagina', novaPagina - 1);
        },
        sortChangeRequest(column) {
            this.$emit('ordenarTabela', column);
        },

        visualizarProcessamento(numeroContrato) {
            this.$router.push({
                name: 'VisualizarProcessamentoContratoOriginacao',
                params: { numeroContrato }
            });
        },

        async irParaContrato(numeroContrato) {
            this.$router.push({
                name: 'PreencherContratoOriginacao',
                params: { numeroContrato }
            });
        }
    }
};
</script>
<style lang="scss">
#tabela-gestao-contrato-originacao {
    box-shadow: 0 0 10px rgb(0 0 0 / 10%);

    .el-table {
        border-top-right-radius: 11px;
        border-top-left-radius: 11px;
        min-height: 240px;
        thead.has-gutter {
            height: 67px;
            th.el-table__cell {
                background-color: #fbfbfb;
            }
        }
    }
    .status-processamento {
        max-width: 148px;
        word-break: break-word;
        font-size: 13px;
        line-height: 17px;
    }
    .tabela-gestao-contrato-originacao__paginacao {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: var(--white);
        padding: 14px 11px;
        border-bottom-left-radius: 11px;
        border-bottom-right-radius: 11px;

        .pagina {
            color: var(--primary);
            font-weight: 600;
        }
    }
    .tabela-gestao-icone {
        i {
            font-size: 27px;
        }
    }
}
</style>
